"use strict";

function MuniOutfallToDoList() {
  function organizeMuniOutfallRoutineInspection(allToDos) {
    for (const toDo of allToDos) {
      ToDoFunctions.addCommonFields(toDo, toDo.muniOutfallRoutineInspection);
      toDo.permissions = {
        ...toDo.permissions,
        canCreateRoutineInspection: toDo.permissions.canCreateOutfallInspection,
      };
    }

    return allToDos;
  }

  function organizeMuniOutfallRoutineMaintenance(allToDos) {
    const result = [...allToDos];

    for (const toDo of result) {
      toDo.muniOutfallRoutineMaintenance = structuredClone(toDo.muniOutfallRoutineMaintenance);
      ToDoFunctions.flattenAdditionalInfoAndCloneExtrasOntoEndOfArray(
        result,
        toDo,
        "muniOutfallRoutineMaintenance",
      );

      ToDoFunctions.addCommonFields(toDo, toDo.muniOutfallRoutineMaintenance);
      toDo.correctiveAction = toDo.muniOutfallRoutineMaintenance.additionalInfo?.key;
      toDo.displayLevel = getDisplayLevel(toDo.muniOutfallRoutineMaintenance.additionalInfo?.level);
    }

    return BmpFcsToDoController.addOutfallRepairConditions(result);
  }

  function getDisplayLevel(level) {
    if (!level) {
      return "Repair";
    }

    return RoutineMaintenanceFormTable.getLevelOptions().find((options) => options.value === level)
      .name;
  }

  function canAccessRoutineInspections(user) {
    return user.permissions.can_create_outfall_inspection;
  }

  function getSortersDict() {
    const dbDateStringSorter = DateTime.dbDateStringComparator;
    const alphaSorter = SortUtilities.alphaSorter;

    return {
      outfallName: alphaSorter,
      zone: alphaSorter,
      address: alphaSorter,
      assignee: ToDoUserPicker.assigneeSort,
      dueDateIso: dbDateStringSorter,
    };
  }

  return {
    organizeMuniOutfallRoutineInspection,
    organizeMuniOutfallRoutineMaintenance,
    canAccessRoutineInspections,
    getSortersDict,
  };
}

module.exports = MuniOutfallToDoList();

const BmpFcsToDoController = require("../../bmpfcs/bmpFcsToDoController");
const DateTime = require("../../dateTime");
const RoutineMaintenanceFormTable = require("../../general/routineMaintenanceFormTable");
const SortUtilities = require("../../general/sortUtilities");
const ToDoFunctions = require("../../mapFunctions/toDoFunctions");
const ToDoUserPicker = require("../../general/toDoUserPicker");
